import { ClientVehicleMapper } from "@/adapters/ClientVehicle.mapper";
import { CLIENT_VEHICLE_COLUMNS } from "@/types/client/clientVehicle.dto";
import { supabase } from "@/utils/supabase";
export class ClientVehicleService {
    async listByClient(clientId) {
        const { data, error } = await supabase()
            .from("vehicles_clients")
            .select(CLIENT_VEHICLE_COLUMNS)
            .eq("idClient", clientId)
            .order("brand", { ascending: true });
        if (error)
            throw error;
        return (data ?? []).map(ClientVehicleMapper.toDomain).filter((vehicle) => vehicle.isActive);
    }
}
export const clientVehicleService = new ClientVehicleService();
